<div class="dialog-header header-simple">
  <h2 mat-dialog-title>
    {{ 'createDoc.signersDialog.title' | transloco }}
  </h2>
  <button mat-icon-button color="primary" (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="form">
  <mat-dialog-content>
    <section class="section">
      <label class="field-label" for="managingDirectorSelect">
        {{ 'createDoc.signersDialog.managingDirectorLabel' | transloco }}
        <span class="required">*</span>
      </label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select id="managingDirectorSelect" formControlName="managingDirectorId">
          <mat-option *ngFor="let p of managingDirectors" [value]="p.personProfileId"> {{ p.firstName }} {{ p.lastName }} </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="info-hint">
        <mat-icon color="primary" inline>info</mat-icon>
        <span>
          {{ 'createDoc.signersDialog.managingDirectorHintPre' | transloco }}
          <a [routerLink]="['/cockpit/data-management/organisation-settings']" (click)="onCancel()">
            {{ 'createDoc.signersDialog.managingDirectorHintLink' | transloco }}
          </a>
          {{ 'createDoc.signersDialog.managingDirectorHintPost' | transloco }}
        </span>
      </div>
      <div *ngIf="selectedManagingDirector" class="person-card">
        <div class="person-icon">
          <mat-icon>person</mat-icon>
        </div>
        <div class="person-details">
          <div class="person-name">
            {{ selectedManagingDirector.firstName }}
            {{ selectedManagingDirector.lastName }}
          </div>
          <div>{{ selectedManagingDirector.email }}</div>
          <div>{{ selectedManagingDirector.phoneNumber }}</div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <div>
          <h3 class="section-title">
            {{ 'createDoc.signersDialog.otherSignerTitle' | transloco }}
          </h3>
          <p class="section-subtitle">
            {{ 'createDoc.signersDialog.otherSignerSubtitle' | transloco }}
          </p>
        </div>
        <mat-slide-toggle formControlName="hasOtherSigner" color="primary"> </mat-slide-toggle>
      </div>
      <ng-container *ngIf="form.value.hasOtherSigner">
        <label class="field-label" for="signerSelect">
          {{ 'createDoc.signersDialog.otherSignerLabel' | transloco }}
        </label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select id="signerSelect" formControlName="signerId">
            <mat-option *ngFor="let p of signers" [value]="p.personProfileId"> {{ p.firstName }} {{ p.lastName }} · {{ p.function }} </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="info-hint">
          <mat-icon color="primary" inline>info</mat-icon>
          <span>
            {{ 'createDoc.signersDialog.otherSignerHintPre' | transloco }}
            <a [routerLink]="['/cockpit/data-management/organisation-settings']" (click)="onCancel()">
              {{ 'createDoc.signersDialog.otherSignerHintLink' | transloco }}
            </a>
            {{ 'createDoc.signersDialog.otherSignerHintPost' | transloco }}
          </span>
        </div>
        <div *ngIf="selectedSigner" class="person-card">
          <div class="person-icon">
            <mat-icon>edit</mat-icon>
          </div>
          <div class="person-details">
            <div class="person-name">{{ selectedSigner.firstName }} {{ selectedSigner.lastName }}</div>
            <div>{{ selectedSigner.function }}</div>
            <div>{{ selectedSigner.email }}</div>
            <div>{{ selectedSigner.phoneNumber }}</div>
          </div>
        </div>
      </ng-container>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onContinue()">
      {{ 'common.buttons.confirm' | transloco }}
    </button>
  </mat-dialog-actions>
</form>
